// eslint-disable-next-line
import util from 'util';

// eslint-disable-next-line
import * as actionTypes from '../actionTypes';

const initialState = {
  callState: 'closed',
  phoneOutcall: {},
  phoneMuted: false,
  phoneOpen: false,
  outdialNumber: '',
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_CALL_STATE : {
      return({...state, callState: action.payload.callState });
    }
    case actionTypes.SET_PHONE_OUTCALL : {
      return({...state, phoneOutcall: action.payload.phoneOutcall });
    }
    case actionTypes.SET_PHONE_MUTED : {
      return({...state, phoneMuted: action.payload.phoneMuted });
    }
    case actionTypes.SET_PHONE_OPEN : {
      return({...state, phoneOpen: action.payload.phoneOpen });
    }
    case actionTypes.SET_OUTDIAL_NUMBER : {
      return({...state, outdialNumber: action.payload.outdialNumber });
    }
    default: {
      return(state);
    }
  }  
}
